import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Landing from "./pages/Landing";
import PunHits from "./pages/PunHits";
import Limericks from "./pages/Limericks";

export default function App() {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/puns" element={<PunHits />} />
        <Route path="/limericks" element={<Limericks />} />
      </Routes>
    </BrowserRouter>
  );
}
